import { reactive } from 'vue';

export let store = {};

const defaults = {
	query: ``,
	location: ``,
	work_environments: [],
	salary_period: ``,
	require_salary: `no`,
	salary_min: null,
	work_schedules: [],
	employment_types: [],
	experiences: [],
	qualifications: [],
	date: ``,
	sort: ``,
	radius: 25,
};

export function create_store(response) {
	store = reactive({
		...response,
		defaults: {
			...defaults,
			...response.defaults,
		},
	});

	return store;
}
